<template>
    <div id="app" v-bind:class="getClasses">
        <Header></Header>
        <div class="content">
            <transition
                        name="fade"
                        mode="out-in">
                <router-view></router-view>
            </transition>
            <Help></Help>
            <FullscreenContainer></FullscreenContainer>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    export default {
        name: "App",
        data: function()
        {
            return {
                backdrop: false,
                showHelp: false,
                babylonLoaded: false,
                muted: true,
                home: true,
                environment: '',
            };
        },
        computed: {
            getClasses()
            {
                let classes = {'is-home' : this.home,
                    'is-muted': this.muted,
                    'has-backdrop': this.backdrop,
                    'help-visible': this.showHelp,
                    'babylon-loaded': this.babylonLoaded,
                };

                if (this.$tracking.environment)
                {
                    classes['env-' + this.$tracking.environment] = true;
                }

                return classes;
            }
        },
        created()
        {
            // Immer auf erster Seite starten
            /*
            if (this.$route.path !== '/')
            {
                //this.$router.push( '/' );
            }
            */

            // Hilfe ein-/ausblenden
            this.$eventBus.$on('help.toggle', () => {
                this.showHelp = !this.showHelp;
            });
            // toggle Audio on/off
            this.$eventBus.$on('audio.toggle', () => {
                this.muted = !this.muted;
                //console.log('audio.toggle, is-muted: ', this.muted);
            });

            // is home?
            this.$eventBus.$on('currentPage', (data) => {
                this.home = (data === 0);

                // bei Seitenwechsel Buttons zurücksetzen
                this.showHelp = false;
            });
        },
        mounted() {

        },
        // Wenn Babylon geladen ist...
        babylonReady: function () {
            this.babylonLoaded = true;

            // Babylon Debug
            if (process.env.NODE_ENV === 'development')
            {
                window.babylonController = this.$babylonController;
                //babylonController.moveCamera(Math.PI/2, 1.4, 20)
                
                //window.babylonController.scene.debugLayer.show();
            }
        }
    };
</script>

<style lang="scss">

    @import "./BabylonStory/assets/scss/base.scss";

</style>
